import { render, staticRenderFns } from "./Experiments.vue?vue&type=template&id=9cb3cba2&scoped=true&"
import script from "./Experiments.vue?vue&type=script&lang=js&"
export * from "./Experiments.vue?vue&type=script&lang=js&"
import style0 from "./Experiments.vue?vue&type=style&index=0&id=9cb3cba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb3cba2",
  null
  
)

export default component.exports